import { useRef, useState } from 'react';
import { Region } from './region'

import { Container, CountryContent, RegionsContainer } from './style';

export function Countries({ country, setListStatesToSearch, listStatesToSearch }) {
    const regionsRef = useRef(null)
    const [openCountryRegions, setOpenCountryRegions] = useState(false)
    const [heightCountryRegions, setHeightCountryRegions] = useState('0px')


    function handleOpenCountryRegions(bool) {
        setHeightCountryRegions(bool ? `${regionsRef.current.scrollHeight}px` : '0px')
    }
    

    return(
        <Container>
          
            <CountryContent 
                onClick={() => {
                    handleOpenCountryRegions(!openCountryRegions)
                    setOpenCountryRegions(!openCountryRegions)
                }}
            >   
            
                <img src={country.flag} alt={country.country}/>
                <h4>{country.country}</h4>
            </CountryContent>
          


            <RegionsContainer 
                ref={regionsRef}
                heightCountryRegions={heightCountryRegions}
            >
                {
                    country.regions.map((region) => (
                        <Region 
                            key={region.idRegion}
                            region={region}
                            setListStatesToSearch={setListStatesToSearch}
                            listStatesToSearch={listStatesToSearch}
                        />
                    ))
                }
            </RegionsContainer>
        </Container>
    )
}
